import { SignalGroupMemberTypes } from "../constants";
import { SignalUser } from "gql/graphql";

/**
 * memberTypeが編集者かどうかを判定する
 * @param signalUser
 * @returns
 */
export function isEditorAuthorization(signalUser: SignalUser): boolean {
  return signalUser.service_agreement && signalUser.member_type === SignalGroupMemberTypes.editor.ordinal;
}
